import { useState } from "react";
import { initializePaddle, getPaddlePriceId } from "@/lib/paddle";

export interface OpenCheckoutOptions {
  priceId: string;
  customerEmail?: string;
  customData?: Record<string, string>;
  successUrl?: string;
}

function readReferralAttribution(): { referralCode?: string } {
  try {
    const raw = window.localStorage.getItem("emrkt-attribution-v1");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.referral_code === "string") {
      return { referralCode: parsed.referral_code };
    }
  } catch {
    // ignore
  }
  return {};
}

export function usePaddleCheckout() {
  const [loading, setLoading] = useState(false);

  const openCheckout = async (options: OpenCheckoutOptions) => {
    setLoading(true);
    try {
      await initializePaddle();
      const paddlePriceId = await getPaddlePriceId(options.priceId);
      const attribution = readReferralAttribution();
      const mergedCustomData = {
        ...(attribution.referralCode ? { referralCode: attribution.referralCode } : {}),
        ...options.customData,
      };
      window.Paddle.Checkout.open({
        items: [{ priceId: paddlePriceId, quantity: 1 }],
        customer: options.customerEmail ? { email: options.customerEmail } : undefined,
        customData: Object.keys(mergedCustomData).length ? mergedCustomData : undefined,
        settings: {
          displayMode: "overlay",
          successUrl: options.successUrl || `${window.location.origin}/account/billing?checkout=success`,
          allowLogout: false,
          variant: "one-page",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return { openCheckout, loading };
}